
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 import { SkyDialog as SkyDialogElement, SkyDialogRequestCloseDetail } from '@sky.ui/core/sky-dialog';
 
 

 
 export const SkyDialog = createComponent({
   displayName: 'SkyDialog',
   react: React,
   tagName: 'sky-dialog',
   elementClass: SkyDialogElement,
   events: {
     
     onRequestClose: 'request-close' as EventName<CustomEvent<SkyDialogRequestCloseDetail>>,
     onDialogOpened: 'dialog-opened' as EventName<CustomEvent<void>>,
     onDialogClosed: 'dialog-closed' as EventName<CustomEvent<void>>,
   }
  });
export type * from '@sky.ui/core/sky-dialog';
